// Design Portfolio Content Data

export const visuallyExplainedData = [
	{
		id: 1,
		image: 've1',
		title: 'Python Decorators - Visually Explained',
		videoUrl: 'https://www.youtube.com/watch?v=3tyaO-OE0K0',
		views: '344k views',
	},
	{
		id: 2,
		image: 've2',
		title: 'Python Functions - Visually Explained',
		videoUrl: 'https://www.youtube.com/watch?v=KW6qncswzHw&t=602s',
		views: '320k views',
	},
	{
		id: 3,
		image: 've3',
		title: 'Python Decorators - Visually Explained',
		videoUrl: 'https://www.youtube.com/watch?v=3tyaO-OE0K0',
		views: '344k views',
	},
	{
		id: 4,
		image: 've4',
		title: 'Python if name == "main" - Visually Explained',
		videoUrl: 'https://www.youtube.com/watch?v=KZpYtNtGxSU&t=156s',
		views: '612k views',
	},
	{
		id: 5,
		image: 've5',
		title: 'Python if name == "main" - Visually Explained',
		videoUrl: 'https://www.youtube.com/watch?v=KZpYtNtGxSU&t=156s',
		views: '612k views',
	},
	{
		id: 6,
		image: 've6',
		title: 'Python Functions - Visually Explained',
		videoUrl: 'https://www.youtube.com/watch?v=KW6qncswzHw&t=602s',
		views: '320k views',
	},
	{
		id: 7,
		image: 've7',
		title: 'Python Lambda Functions - Visually Explained',
		videoUrl: 'https://www.youtube.com/watch?v=j6FCewxjrBM&t=62s',
		views: '224k views',
	},
	{
		id: 8,
		image: 've8',
		title: 'Python Functions - Visually Explained',
		videoUrl: 'https://www.youtube.com/watch?v=KW6qncswzHw&t=602s',
		views: '320k views',
	},
];

export const loopData = [
	{
		id: 1,
		image: 'loop1',
		description: 'Main calendar view',
	},
	{
		id: 2,
		image: 'loop2',
		description: 'Single workout view',
	},
	{
		id: 3,
		image: 'loop3',
		description: 'Workout manual laps',
	},
	{
		id: 4,
		image: 'loop4',
		description: 'Workout auto laps',
	},
	{
		id: 5,
		image: 'loop5',
		description: 'Workout smart segments and fastest segments',
	},
	{
		id: 6,
		image: 'loop6',
		description: 'Workout metric charts',
	},
	{
		id: 7,
		image: 'loop7',
		description: 'Workout power data view',
	},
	{
		id: 8,
		image: 'loop8',
		description: 'Weekly trends',
	},
];

export const finToolsData = [
	{
		id: 1,
		image: 'ft3',
		caption: 'Single option visualizers',
	},
	{
		id: 2,
		image: 'ft4',
		caption: 'Custom options spread visualizer',
	},
	{
		id: 3,
		image: 'ft1',
		caption: 'Black-Scholes calculator',
	},
	{
		id: 4,
		image: 'ft2',
		caption: 'Binomial model',
	},
];
